import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibChevronDownIcon } from '@chewy/kib-icons-react'

import type { IdentifiedAttachmentOrigin } from '~/types'

import MessageAttachment from './message-attachment/MessageAttachment'

import styles from './AttachmentRow.module.scss'

const AttachmentRow = ({
  attachments,
  ariaLabelledBy,
}: {
  ariaLabelledBy: string
  attachments: IdentifiedAttachmentOrigin[]
}) => {
  const { t } = useTranslation('Common')

  return (
    <div
      aria-labelledby={ariaLabelledBy}
      className={styles.attachmentRow}
      role="radiogroup"
    >
      <span className={styles.attachmentLabel} id={ariaLabelledBy}>
        {t('Common:ATTACHMENTS')}:
      </span>
      {attachments.map((attachment) => (
        <MessageAttachment
          attachment={attachment}
          choiceGroupName="attachment group"
          key={attachment.id}
        />
      ))}
      {/* TODO: CVC-32587: Implement expand/collapse attachment row */}
      {attachments.length > 1 && (
        <KibButtonNew
          className={styles.expandButtton}
          icon={<KibChevronDownIcon />}
          iconPosition="end"
          size="small"
        >
          {t('Common:EXPAND_ACTION')}
        </KibButtonNew>
      )}
    </div>
  )
}

export default AttachmentRow
